import React, { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import {
  Container, Row, Col, Button,
} from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../../../components/Navbar';
import Header from '../../../../components/Header';
import { DetailProgresStyle } from './style';
import { Loader } from '../../../Superadmin/TambahAdmin/styles';
import UnifyButton from '../../../../components/Button';
import Atribut from './atribut';
import config from '../../../../config';
import ModalPoster from '../UnggahPoster';

const DetailProgres = () => {
  const history = useHistory();
  const { idProgres } = useParams();
  const [loading, setLoading] = useState(true);
  const [showPoster, setShowPoster] = useState(false);
  const [content, setContent] = useState({
    deskripsi: '',
    id: 0,
    jabatan: '',
    kum_id: {
      biaya: '0.0',
      id: 0,
      image_url: '',
      jenis_kegiatan: '',
      link_regis: '',
      lokasi: '',
      moderator: '',
      nama_kegiatan: '',
      nilai_kum: '0.0',
      pembicara: '',
      penyelenggara: '',
      pukul: '00:00:00',
      sertifikat: '',
      tanggal: '2000-01-01',
      deskripsi: '',
    },
    nama_organisasi: '',
    no_telepon: '',
    proposal: '',
    status: '',
    feedback: '',
  });

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}api/pengajuan_kuliah_umum/detail/${idProgres}/`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      ({ data }) => {
        const tempData = data;
        if (tempData.kum_id.biaya) {
          tempData.kum_id.biaya = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(data.kum_id.biaya);
        }
        setContent(tempData);
      },
    );
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  return (
    <>
      <Navbar />
      <Header />
      <DetailProgresStyle>
        <Container className="container-list">
          <UnifyButton
            color="#F9B114"
            textColor="#373736"
            className="font-20 btn-kembali"
            onClick={() => history.goBack()}
          >
            {'\u2190 Kembali'}
          </UnifyButton>
          <h1 className="text-center mb-2 font-32">Detail Progres Pengajuan Kegiatan KUM</h1>
          <Row className="mt-5 ml-1 mr-1">
            <Col className="mr-1">
              <Atribut nama="Nama Kegiatan" data={content.kum_id.nama_kegiatan} />
              <Atribut nama="Hari/Tanggal" data={content.kum_id.tanggal} />
              <Atribut nama="Biaya" data={content.kum_id.biaya} />
              <Atribut nama="Moderator" data={content.kum_id.moderator} />
              <Atribut nama="Lokasi" data={content.kum_id.lokasi} />
              <Atribut nama="Status" data={content.status} />
              <Atribut nama="Feedback" data={content.feedback} />
            </Col>
            <Col className=" ml-1">
              <Atribut nama="Jenis Kegiatan" data={content.kum_id.jenis_kegiatan} />
              <Atribut nama="Pukul" data={content.kum_id.pukul} />
              <Atribut nama="Link Registrasi" data={content.kum_id.link_regis} />
              <Atribut nama="Pembicara" data={content.kum_id.pembicara} />
              <Atribut nama="Sertifikat" data={content.kum_id.sertifikat} />
              <div className="detail-atribut justify-content-between">
                <h4 className="font-24">Proposal</h4>
                <p className="font-20"><a href={content.proposal} className="link-proposal">Proposal</a></p>
              </div>
              <Atribut nama="Deskripsi" data={content.kum_id.deskripsi} />
            </Col>
          </Row>
          {
            content.status === 'disetujui'
            && (
              <Row className="mt-2">
                <Col className="text-center">
                  <Button
                    className="btnAction btn-primary font-20"
                    variant="success"
                    onClick={() => setShowPoster(true)}
                    data-testid="poster"
                  >
                    Unggah Poster
                  </Button>
                </Col>
                <ModalPoster
                  id={content.id}
                  show={showPoster}
                  onHide={() => setShowPoster(false)}
                  history={history}
                />
              </Row>
            )
          }
        </Container>
      </DetailProgresStyle>
    </>
  );
};

export default DetailProgres;
